import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { ShipmentCostService } from 'common/data';

class ShipmentCostStore extends BaseStore {
	constructor(rootStore) {
		super(new ShipmentCostService(rootStore.app.baasic.apiClient));
	}

	@action
	async findTn(data) {
		const response = await this.service.findTn(data);
		this.response = response.data;
		return response;
	}

	@action
	async findCharge(data) {
		const response = await this.service.findCharge(data);
		this.response = response.data;
		return response;
	}

	@action
	async uploadBillData(data, isOverride, sourceOfChange) {
		const response = await this.service.uploadBillData(data, isOverride, sourceOfChange);
		this.response = response.data;
		return response;
	}

	@action
	async checkTrackingNumbers(data) {
		const response = await this.service.checkTrackingNumbers(data);
		return response.data;
	}

	@action
	deleteInvoice = async invoiceNumber => {
		await this.service.deleteInvoice(invoiceNumber);
	};
}

export default ShipmentCostStore;
